
import TalkPart from './index.vue'

TalkPart.install = function (Vue) {
  Vue.component(TalkPart.name, TalkPart)
}

export default TalkPart